// =========================================================
// Side thumbnails per galleria prodotto Horizon
// Smooth scroll on click + active state via IntersectionObserver
// =========================================================
(function () {
  const init = () => {
    document.querySelectorAll('[data-grid-thumbnails-wrapper]').forEach((wrapper) => {
      const thumbnails = wrapper.querySelectorAll('[data-thumb-target]');
      const grid = wrapper.querySelector('[data-grid-target]');
      if (!thumbnails.length || !grid) return;

      // --- Click: smooth scroll alla foto corrispondente ---
      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = thumb.dataset.thumbTarget;
          const target = document.getElementById(targetId);
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      // --- Active state mentre l'utente scrolla la pagina ---
      const items = grid.querySelectorAll('li[id^="media-"]');
      if (!items.length) return;

      const setActive = (activeId) => {
        thumbnails.forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.dataset.thumbTarget === activeId);
        });
      };

      const observer = new IntersectionObserver(
        (entries) => {
          // Considera tutte le entry visibili e trova quella più al top del viewport
          const visible = entries
            .filter((e) => e.isIntersecting)
            .map((e) => ({
              id: e.target.id,
              top: e.boundingClientRect.top,
              ratio: e.intersectionRatio,
            }))
            .sort((a, b) => a.top - b.top);

          if (visible.length > 0) {
            setActive(visible[0].id);
          }
        },
        {
          // Considera "attiva" l'immagine che occupa la parte alta-centrale del viewport
          rootMargin: '-20% 0px -60% 0px',
          threshold: [0, 0.1, 0.5, 1],
        }
      );

      items.forEach((item) => observer.observe(item));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-inizializza dopo eventuali update dell'editor Shopify (live preview)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
